<app-header navScreen="Home" class="mb-5"></app-header>
<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>

<div class="row text-center ka-em-payment-details-header">
    <h2>Master Page</h2>
</div>

<mat-tab-group>
    <mat-tab label="Education">
        <form class="row p-2" [formGroup]="educationMasterForm">
                <div class="col-md-4">
                    <div *ngIf="listOfEduCategory.length <= 0">
                        <mat-chip-list #chipListEduCategory>
                            <label for="highestEducation">Education Category : </label>
                            <input type="text" formControlName="highestEducation" (focusout)="clearText($event)" id="highestEducation" matInput
                            class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="EduCategory" [matChipInputFor]="chipListEduCategory"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addEduCategoryChip($event)">
                        </mat-chip-list>
                        <mat-autocomplete #EduCategory="matAutocomplete" (optionSelected)="getSelectedEduCategory($event)"
                            [displayWith]="getCityText">
                            <mat-option *ngFor="let option of searchableEduCategoryList; let i=index" [value]="option">
                            {{option.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div *ngIf="listOfEduCategory.length > 0">
                        <div class="col-md mt-3 p-0 flexRows">
                        <div class="col-md-12 p-0">
                            <p class="label-text">Selected Category</p>
                        </div>
                        <div class="col-md-12 p-0">
                            <mat-chip *ngFor="let data of listOfEduCategory"
                            [selectable]="selectable" [removable]="removable" (removed)="removeCategory(data)"> {{data.value}}
                            <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                            </mat-chip>
                        </div>
                        </div>
                    </div>
                    <div *ngIf="addEduCategory">
                    <button (click)="addToMasterData('HighestEducation', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                    </div>
                </div>
                <div class="col-md-4" *ngIf="listOfEduCategory.length > 0">
                    <div *ngIf="listOfEduGroup.length <= 0">
                        <mat-chip-list #chipListEduGroup>
                            <label for="educationGroup">Education Group : </label>
                            <input type="text" formControlName="educationGroup" (focusout)="clearText($event)" id="educationGroup" matInput
                            class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="aut" [matChipInputFor]="chipListEduGroup"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addEduGroupChip($event)">
                        </mat-chip-list>
                        <mat-autocomplete #aut="matAutocomplete" (optionSelected)="getSelectedEduGroup($event)"
                            [displayWith]="getCityText">
                            <mat-option *ngFor="let option of searchableEduGroupList; let i=index" [value]="option">
                            {{option.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div *ngIf="listOfEduGroup.length > 0">
                        <div class="col-md mt-3 p-0 flexRows">
                        <div class="col-md-12 p-0">
                            <p class="label-text">Selected Group</p>
                        </div>
                        <div class="col-md-12 p-0">
                            <mat-chip *ngFor="let data of listOfEduGroup"
                            [selectable]="selectable" [removable]="removable" (removed)="removeGroup(data)"> {{data.value}}
                            <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                            </mat-chip>
                        </div>
                        </div>
                    </div>
                    <div *ngIf="addEduGroup">
                    <button (click)="addToMasterData('educationGroup', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                    </div>
                </div>


                <div class="col-md-4" *ngIf="listOfEduGroup.length > 0">
                    <div *ngIf="listOfEduSpecialization.length <= 0">
                        <mat-chip-list #chipListEduSpecialization>
                            <label for="specialization">Education Specialization : </label>
                            <input type="text" formControlName="specialization" (focusout)="clearText($event)" id="specialization" matInput
                            class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="aut" [matChipInputFor]="chipListEduSpecialization"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addEduSpecializationChip($event)">
                        </mat-chip-list>
                        <mat-autocomplete #aut="matAutocomplete" (optionSelected)="getSelectedEduSpecialization($event)"
                            [displayWith]="getCityText">
                            <mat-option *ngFor="let option of searchableEduSpecializationList; let i=index" [value]="option">
                            {{option.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div *ngIf="listOfEduSpecialization.length > 0">
                        <div class="col-md mt-3 p-0 flexRows">
                        <div class="col-md-12 p-0">
                            <p class="label-text">Selected Specialization</p>
                        </div>
                        <div class="col-md-12 p-0">
                            <mat-chip *ngFor="let data of listOfEduSpecialization"
                            [selectable]="selectable" [removable]="removable" (removed)="removeSpecialization(data)"> {{data.value}}
                            <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                            </mat-chip>
                        </div>
                        </div>
                    </div>
                    <div *ngIf="addEduSpecialization">
                    <button (click)="addToMasterData('specialization', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                    </div>
                </div>
                <!-- <div class="col-md-4" *ngIf="listOfEduSpecialization.length != 0 || listOfEduGroup.length != 0 || listOfEduCategory.length != 0">
                    <button (click)="addToMasterData('inactive', 1)" class=" m-2 ka-emp-inactiveMasterData"  mdbWavesEffect type="submit"> Make Inactive </button>
                </div> -->

        </form>
    </mat-tab>
    <mat-tab label="Profession">
        <form class="row p-2" [formGroup]="professionMasterForm">
            <div class="col-md-4">
                <div *ngIf="listOfProfCategory.length <= 0">
                    <mat-chip-list #chipListProfCategory>
                        <label for="highestprofession">Profession Category : </label>
                        <input type="text" formControlName="highestprofession" (focusout)="clearText($event)" id="highestprofession" matInput
                        class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="prof" [matChipInputFor]="chipListProfCategory"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addProfCategoryChip($event)">
                    </mat-chip-list>
                    <mat-autocomplete #prof="matAutocomplete" (optionSelected)="getSelectedProfCategory($event)"
                        [displayWith]="getCityText">
                        <mat-option *ngFor="let option of searchableProfCategoryList; let i=index" [value]="option">
                        {{option.value}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
                <div *ngIf="listOfProfCategory.length > 0">
                    <div class="col-md mt-3 p-0 flexRows">
                    <div class="col-md-12 p-0">
                        <p class="label-text">Selected Category</p>
                    </div>
                    <div class="col-md-12 p-0">
                        <mat-chip *ngFor="let data of listOfProfCategory"
                        [selectable]="selectable" [removable]="removable" (removed)="removeProfCategory(data)"> {{data.value}}
                        <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                        </mat-chip>
                    </div>
                    </div>
                </div>
                <div *ngIf="addProfCategory">
                <button (click)="addToMasterData('highestprofession', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                </div>
            </div>
            <div class="col-md-4" *ngIf="listOfProfCategory.length > 0">
                <div *ngIf="listOfProfGroup.length <= 0">
                    <mat-chip-list #chipListProfGroup>
                        <label for="professionGroup">Profession Group : </label>
                        <input type="text" formControlName="professionGroup" (focusout)="clearText($event)" id="professionGroup" matInput
                        class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="ProfGroup" [matChipInputFor]="chipListProfGroup"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addProfGroupChip($event)">
                    </mat-chip-list>
                    <mat-autocomplete #ProfGroup="matAutocomplete" (optionSelected)="getSelectedProfGroup($event)"
                        [displayWith]="getCityText">
                        <mat-option *ngFor="let option of searchableProfGroupList; let i=index" [value]="option">
                        {{option.value}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
                <div *ngIf="listOfProfGroup.length > 0">
                    <div class="col-md mt-3 p-0 flexRows">
                    <div class="col-md-12 p-0">
                        <p class="label-text">Selected Group</p>
                    </div>
                    <div class="col-md-12 p-0">
                        <mat-chip *ngFor="let data of listOfProfGroup"
                        [selectable]="selectable" [removable]="removable" (removed)="removeProfGroup(data)"> {{data.value}}
                        <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                        </mat-chip>
                    </div>
                    </div>
                </div>
                <div *ngIf="addProfGroup">
                <button (click)="addToMasterData('professionGroup', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                </div>
            </div>


            <div class="col-md-4" *ngIf="listOfProfGroup.length > 0">
                <div *ngIf="listOfProfSpecialization.length <= 0">
                    <mat-chip-list #chipListProfSpecialization>
                        <label for="profSpecialization">Profession Specialization : </label>
                        <input type="text" formControlName="profSpecialization" (focusout)="clearText($event)" id="profSpecialization" matInput
                        class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="ProfSpecialization" [matChipInputFor]="chipListProfSpecialization"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addProfSpecializationChip($event)">
                    </mat-chip-list>
                    <mat-autocomplete #ProfSpecialization="matAutocomplete" (optionSelected)="getSelectedProfSpecialization($event)"
                        [displayWith]="getCityText">
                        <mat-option *ngFor="let option of searchableProfSpecializationList; let i=index" [value]="option">
                        {{option.value}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
                <div *ngIf="listOfProfSpecialization.length > 0">
                    <div class="col-md mt-3 p-0 flexRows">
                    <div class="col-md-12 p-0">
                        <p class="label-text">Selected Specialization</p>
                    </div>
                    <div class="col-md-12 p-0">
                        <mat-chip *ngFor="let data of listOfProfSpecialization"
                        [selectable]="selectable" [removable]="removable" (removed)="removeProfSpecialization(data)"> {{data.value}}
                        <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                        </mat-chip>
                    </div>
                    </div>
                </div>
                <div *ngIf="addProfSpecialization">
                <button (click)="addToMasterData('profSpecialization', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                </div>
            </div>
            <!-- <div class="col-md-4" *ngIf="listOfProfSpecialization.length != 0 || listOfProfGroup.length != 0 || listOfProfCategory.length != 0">
                <button (click)="addToMasterData('inactive', 2)" class=" m-2 ka-emp-inactiveMasterData"  mdbWavesEffect type="submit"> Make inactive </button>
            </div> -->

        </form>
    </mat-tab>
    <mat-tab label="University">
        <form class="row p-2" [formGroup]="universityMasterForm">
            <div class="col-md-4">
                <div>
                    <mat-chip-list #chipListUniversity>
                        <label for="university">University Name : </label>
                        <input type="text" formControlName="university" (focusout)="clearText($event)" id="university" matInput
                        class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="prof" [matChipInputFor]="chipListUniversity"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addUniversityChip($event)">
                    </mat-chip-list>
                    <mat-autocomplete #prof="matAutocomplete" (optionSelected)="getSelectedUniversity($event)"
                        [displayWith]="getCityText">
                        <mat-option *ngFor="let option of searchableUniversityList; let i=index" [value]="option">
                        {{option.value}}
                        </mat-option>
                    </mat-autocomplete>
                </div>
            </div>

            <div *ngIf="universityToMD">
            <button (click)="addToMasterData('university', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
            </div>
            <!-- <div class="col-md-4" *ngIf="listOfProfSpecialization.length != 0 || listOfProfGroup.length != 0 || listOfProfCategory.length != 0">
                <button (click)="addToMasterData('inactive', 2)" class=" m-2 ka-emp-inactiveMasterData"  mdbWavesEffect type="submit"> Make inactive </button>
            </div> -->

        </form>
    </mat-tab>

    <mat-tab label="City">
        <form class="row p-2" [formGroup]="cityMasterForm">
                <span class="col-md-4">
                    <div *ngIf="listOfCountries.length <= 0">
                        <mat-chip-list #chipListCountry>
                            <label for="highestEducation"> Country : </label>
                            <input type="text" formControlName="country" (focusout)="clearText($event)" (input)="onInputCountryChange($event)" id="country" matInput
                            class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="country" [matChipInputFor]="chipListCountry"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addCountryChip($event)">
                        </mat-chip-list>
                        <mat-autocomplete #country="matAutocomplete" (optionSelected)="getSelectedType($event, 'Country')"
                            [displayWith]="getCityText">
                            <mat-option *ngFor="let option of searchableCountryList; let i=index" [value]="option">
                            {{option.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div *ngIf="listOfCountries.length > 0">
                        <div class="col-md mt-3 p-0 flexRows">
                        <div class="col-md-12 p-0">
                            <p class="label-text">Selected Country</p>
                        </div>
                        <div class="col-md-12 p-0">
                            <mat-chip *ngFor="let data of listOfCountries"
                            [selectable]="selectable" [removable]="removable" (removed)="removeCountry(data)"> {{data.value}}
                            <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                            </mat-chip>
                        </div>
                        </div>
                    </div>
                </span>
                <span *ngIf="addCountry">
                    <button (click)="addToMasterData('Country', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                </span>
                <span class="col-md-4" *ngIf="listOfCountries.length > 0" style="margin-left: 20%;">
                    <div *ngIf="listOfStates.length <= 0">
                        <mat-chip-list #chipListState>
                            <label for="educationGroup">State : </label>
                            <input type="text" formControlName="state" (focusout)="clearText($event)" (input)="onInputStateChange($event)" id="state" matInput
                            class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="aut" [matChipInputFor]="chipListState"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addStateChip($event)">
                        </mat-chip-list>
                        <mat-autocomplete #aut="matAutocomplete" (optionSelected)="getSelectedType($event, 'State')"
                            [displayWith]="getCityText">
                            <mat-option *ngFor="let option of searchableStateList; let i=index" [value]="option">
                            {{option.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div *ngIf="listOfStates.length > 0">
                        <div class="col-md mt-3 p-0 flexRows">
                        <div class="col-md-12 p-0">
                            <p class="label-text">Selected State</p>
                        </div>
                        <div class="col-md-12 p-0">
                            <mat-chip *ngFor="let data of listOfStates"
                            [selectable]="selectable" [removable]="removable" (removed)="removeState(data)"> {{data.value}}
                            <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                            </mat-chip>
                        </div>
                        </div>
                    </div>
                </span>
                <span *ngIf="addState">
                    <button (click)="addToMasterData('StateBasedOnId', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                </span>

                <span class="col-md-4" *ngIf="listOfStates.length > 0 && selectedCountry == 1" style="padding-top: 3%">
                    <div *ngIf="listOfDistricts.length <= 0">
                        <mat-chip-list #chipListDistrict>
                            <label for="district">District : </label>
                            <input type="text" formControlName="district" (focusout)="clearText($event)" (input)="onInputDistrictChange($event)" id="district" matInput
                            class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="aut" [matChipInputFor]="chipListDistrict"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addDistrictChip($event)">
                        </mat-chip-list>
                        <mat-autocomplete #aut="matAutocomplete" (optionSelected)="getSelectedType($event, 'District')"
                            [displayWith]="getCityText">
                            <mat-option *ngFor="let option of searchableDistrictList; let i=index" [value]="option">
                            {{option.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div *ngIf="listOfDistricts.length > 0">
                        <div class="col-md mt-3 p-0 flexRows">
                        <div class="col-md-12 p-0">
                            <p class="label-text">Selected District</p>
                        </div>
                        <div class="col-md-12 p-0">
                            <mat-chip *ngFor="let data of listOfDistricts"
                            [selectable]="selectable" [removable]="removable" (removed)="removeDistrict(data)"> {{data.value}}
                            <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                            </mat-chip>
                        </div>
                        </div>
                    </div>
                </span>
                <span *ngIf="addDistrict" style="margin-top: 2%;">
                    <button (click)="addToMasterData('DistrictBasedOnId', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                </span>
            
                <span class="col-md-3" *ngIf="((listOfDistricts.length > 0) || (listOfStates.length > 0 && this.selectedCountry != 1))" style="padding-top: 3%;"
                    [ngStyle]="{'margin-left': (listOfDistricts.length > 0) ? '20%' : ''}">
                    <div *ngIf="listOfCities.length <= 0">
                        <mat-chip-list #chipListCity>
                            <label for="city">City : </label>
                            <input type="text" formControlName="city" (focusout)="clearText($event)" (input)="onInputCityChange($event)" id="city" matInput
                            class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="aut" [matChipInputFor]="chipListCity"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addCityChip($event)">
                        </mat-chip-list>
                        <mat-autocomplete #aut="matAutocomplete" (optionSelected)="getSelectedType($event, 'City')"
                            [displayWith]="getCityText">
                            <mat-option *ngFor="let option of searchableCityList; let i=index" [value]="option">
                            {{option.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div *ngIf="listOfCities.length > 0">
                        <div class="col-md mt-3 p-0 flexRows">
                        <div class="col-md-12 p-0">
                            <p class="label-text">Selected City</p>
                        </div>
                        <div class="col-md-12 p-0">
                            <mat-chip *ngFor="let data of listOfCities"
                            [selectable]="selectable" [removable]="removable" (removed)="removeCity(data)"> {{data.value}}
                            <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                            </mat-chip>
                        </div>
                        </div>
                    </div>
                </span>
                <span *ngIf="addCity" style="padding-top: 2%">
                    <button (click)="addToMasterData('CityBasedOnId', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                </span>

        </form>
    </mat-tab>


    <mat-tab label="Caste">
        <form class="row p-2" [formGroup]="casteMasterForm">
                <span class="col-md-4">
                    <div *ngIf="listOfCastes.length <= 0">
                        <mat-chip-list #chipListCaste>
                            <label for="caste"> Caste : </label>
                            <input type="text" formControlName="caste" (focusout)="clearText($event)" (input)="onInputCasteChange($event)" id="caste" matInput
                            class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="matCaste" [matChipInputFor]="chipListCaste"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="addCasteChip($event)">
                        </mat-chip-list>
                        <mat-autocomplete #matCaste="matAutocomplete" (optionSelected)="getSelectedType($event, 'Caste')"
                            [displayWith]="getCityText">
                            <mat-option *ngFor="let option of searchableCasteList; let i=index" [value]="option">
                            {{option.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                    <div *ngIf="listOfCastes.length > 0">
                        <div class="col-md mt-3 p-0 flexRows">
                        <div class="col-md-12 p-0">
                            <p class="label-text">Selected Caste</p>
                        </div>
                        <div class="col-md-12 p-0">
                            <mat-chip *ngFor="let data of listOfCastes"
                            [selectable]="selectable" [removable]="removable" (removed)="removeCaste(data)"> {{data.value}}
                            <i matChipRemove *ngIf="removable" class="fa fa-times"></i>
                            </mat-chip>
                        </div>
                        </div>
                    </div>
                </span>
                <span *ngIf="addCaste">
                    <button (click)="addToMasterData('caste', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                </span>
                <span class="col-md-4" *ngIf="listOfCastes.length > 0" style="margin-left: 20%;">
                    <div *ngIf="listOfSubCastes.length <= 0">
                        <mat-chip-list #chipListCaste>
                            <label for="subcaste">Caste No Bar List : </label>
                            <input type="text" formControlName="subcaste" (focusout)="clearText($event)" (input)="onInputSubCasteChange($event)" id="subcaste" matInput
                            class="form-control" placeholder="Enter atleast 3 Digits" [matAutocomplete]="aut" [matChipInputFor]="chipListCaste"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                        </mat-chip-list>
                        <mat-autocomplete #aut="matAutocomplete" (optionSelected)="getSelectedType($event, 'State')"
                            [displayWith]="getCityText">
                            <mat-option *ngFor="let option of searchableSubCasteList; let i=index" [value]="option">
                            {{option.value}}
                            </mat-option>
                        </mat-autocomplete>
                    </div>
                </span>
                <span *ngIf="addSubCaste">
                    <button (click)="addToMasterData('GroupCaste', false)" class=" m-2 ka-emp-addMasterData"  mdbWavesEffect type="submit"> Add </button>
                </span>
        </form>
    </mat-tab>
</mat-tab-group>

<div mdbModal #successModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true"
  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document">

    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="successModal.hide()">
        <span aria-hidden="true" class="">&times;</span>
      </button>
      <div class="row text-left">

        <!--Grid column-->
        <div class="col-md-12 rmSectionPopup">
          <div class="row p-2 m-2">

            <div class="col-md-12 rmDetailsSectionPopup" style="text-align: center;">
              <!-- <img src="../../../../assets/img/dashboard/rm_temp.PNG" /> -->
              <p class="mt-2 p-0">{{responseMessage}} </p>

              <div class="action-buttons">
                <button mdbBtn class="ka-white-button  tButton ka-btn-primary btn-success btn mb-3 mt-2" mdbWavesEffect
                  type="submit" (click)="successModal.hide()">ok
                </button>



              </div>

            </div>
          </div>

        </div>

        <!--Grid column-->



      </div>
    </div>
  </div>
</div>